/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ngxImageZoomContainer[_ngcontent-%COMP%]{width:auto!important;height:auto!important}"];
export { styles as styles };
